<template lang="html">
  <div class="help-block" name="fade" v-show="hasHint">
    <slot>
      <template v-if="hint">{{ hint }}</template>
    </slot>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'payout-input-hint-block',
})
export default class PayoutInputHintBlock extends Vue {
  @Prop({default: ''})
  hint: string | null

  @Prop({default: false})
  forceShow: boolean

  get hasHint(): boolean {
    return this.forceShow || (this.hint && (this.hint.length > 0));
  }
}
</script>

<style scoped>

</style>
